<template>
    <div id="product-reviews">
        <div v-show="loader || reviewLoader || countLoader || vocLoader">
            <Loader />
        </div>
        <div class="card datepickerwrap mt-4 d-flex flex-row justify-content-between">
            <div class="d-flex flex-row gap">
                <div>
                    <div class="mb-1 ml-1 label">Date Range</div>
                    <date-range-picker v-model="dateRange" :show-dropdowns="true" opens='right' :autoApply="true"
                        :locale-data="{ format: 'dd mmm yyyy' }" :min-date="minDate" :max-date="maxDate"
                        :ranges="false">
                    </date-range-picker>
                </div>
                <div class="customSelect" v-if="platforms.length">
                    <div class="mb-1 ml-1 label">Platform</div>
                    <select v-model="selectedPlatform" @change="changePlatform"
                        class="form-control text-uppercase platform-select">
                        <option v-for="platform of platforms" :key="platform.platform_link" :value="platform">
                            {{ platform.platform_name.replaceAll("_", " ") }}
                        </option>
                    </select>
                </div>
                <div v-if="Object.keys(categories).length">
                    <div class="mb-1 ml-1 label">Category</div>
                    <div class="customMultiselect" style="width: 250px;">
                        <multiselect v-model="selectedCategory" :options="categories[selectedPlatform.platform_name]"
                            :multiple="false" :searchable="false" placeholder="Select Categories" label="value"
                            track-by="key" :showLabels="false" :close-on-select="true" @input="getAllProducts">
                            <!-- <template #selection="{ values, search, isOpen }">
                                <span class="multiselect__single" v-if="values.length" v-show="!isOpen">
                                    {{ values.length }} options selected
                                </span>
                            </template> -->
                        </multiselect>
                    </div>
                </div>
                <div class="d-flex flex-row align-items-center gap" style="margin-top: 20px;">
                    <!-- Filter and Download Buttons -->
                    <button class="btn primarycolor" @click="applyFilters">
                        Apply Filters
                    </button>
                    <button class="btn navigation-btn" v-if="productCompare" @click="backToTopPerformance">
                        Back
                    </button>
                    <button class="btn navigation-btn" v-if="productCompare" @click="goToProductSentiments">
                        Show Sentiments
                    </button>
                </div>
            </div>
            <div class="d-flex align-items-center" style="margin-top: 20px;">
                    <button @click="downloadReviews" class="btn primarycolor">
                        Download
                    </button>
                </div>
        </div>
        <div class="card" v-if="productCompare">
            <div class="d-flex align-items-center"
                :class="selectedView ? 'justify-content-between' : 'justify-content-end'">
                <div class="d-flex justify-content-start" v-if="selectedView">
                    <div class="graphHeading pb-2 mr-3">{{ selectedView.view_name }}</div>
                    <div class="cursor-pointer" @click="openViewModal('Edit View')">
                        <img src="../../../public/Icons_SVG/editBtn.svg" style="width: 15px; height: 15px;" />
                    </div>
                    <div class="cursor-pointer ml-3" @click="showDeleteModal = true">
                        <img src="../../../public/Icons_SVG/deleteBtnSvg.svg" style="width: 15px; height: 15px;;" />
                    </div>
                </div>
                <div class="d-flex justify-content-end align-items-end">
                    <div style="margin-inline: 0.5rem;">
                        <div class="mb-1 ml-1" style="font-size:14px; font-weight:400; color:#1E1E1E">Select View
                            Name</div>
                        <div class="customMultiselect" style="width:250px; margin-bottom: -5px;">
                            <multiselect v-model="selectedView" :options="viewOptions" :multiple="false"
                                :searchable="false" placeholder="Select View" label="view_name" track-by="view_id"
                                :showLabels="false" :close-on-select="true" :allow-empty="false"
                                @input="getSelectedSavedView">
                            </multiselect>
                        </div>
                    </div>
                    <div class="d-flex align-items-end">
                        <button @click="resetSavedView" class="btn primarycolor mr-2 d-flex item-items-center">
                            <span class="newComparisonIcon">
                                <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <path
                                        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z">
                                    </path>
                                </svg>
                            </span>
                            <span>Add New View</span>
                        </button>
                    </div>
                    <div class="d-flex justify-content-end align-items-center">
                        <button class="btn navigation-btn" @click="openViewModal('Save View')">
                            <span>Save View</span>
                        </button>
                    </div>

                </div>
            </div>
        </div>
        <div>
            <div class="card mx-2 position-relative" v-if="!productCompare">
                <ul class="tabs">
                    <li v-for="tab of tabs" :key="tab" @click="switchTab(tab)"
                        :class="{ 'active': tab === selectedTab }">
                        {{ tab }}
                    </li>
                </ul>
                <button class="btn primarycolor" @click="setProductComparison"
                    style="position: absolute; top: 0.5rem; right: 1rem;">Compare</button>
                <b-row>
                    <b-col v-for="product of topProducts" :key="product.product_name" class="mt-4">
                        <div class="product-section-card">
                            <LogoContainer :imgSrc="product.product_image"
                                :placeholder="product.product_image ? false : true" :imageHeight="170" />
                            <div class="px-3 py-2 mt-3 d-flex flex-column align-items-between">
                                <a :href="product.product_link" target="_blank" class="multiline-ellipsis"
                                    :title="product.product_name">{{ product.product_name }}</a>
                                <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: end;">
                                    <div class="d-flex justify-content-between align-items-center mt-3 pt-3">
                                        <div>
                                            <span style="font-size: 14px; color: #065559; font-weight: 600;">{{
                                                product.rating.toFixed(2) }}</span>
                                            <span style="font-size: 14px; color: #0655598D; font-weight: 600;">
                                                /5</span>
                                        </div>
                                        <div style="font-size: 14px; color: #5E5E5E; font-weight: 600;">{{
                                            product.rating_count }}
                                            Reviews</div>
                                    </div>
                                    <div class="container">
                                        <div class="d-inline-flex">
                                            <IconStar v-for="i in maxRating" :key="i" class="star" />
                                        </div>
                                        <div class="overlay"
                                            :style="{ width: `${100 - percentage(product.rating)}%` }" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </div>
            <div class="ml-1 mr-2" v-else-if="productCompare">
                <b-row no-gutters class="mb-4">
                    <b-col cols="4">
                        <div>
                            <div class="compare-card">
                                <b-row>
                                    <b-col>
                                        <LogoContainer :imgSrc="comparisonList[0].img"
                                            :placeholder="comparisonList[0].img ? false : true" :imageHeight="170" />
                                    </b-col>
                                    <b-col class="px-2 d-flex flex-column justify-content-between" style="gap: 8px">
                                        <div class="mb-4 mt-2" style="font-size: 16px;">
                                            <span class="font-weight-bold text-capitalize" style="color: #065559;">{{
                                                selectedCategory.value }}:
                                            </span>
                                            <span class="text-capitalize">{{
                                                comparisonList[0].selectedProduct &&
                                                comparisonList[0].selectedProduct.split("+")[0]
                                                }}</span>
                                            <div class="mt-2" style="color: #5e5e5e;">{{
                                                comparisonList[0].selectedProduct &&
                                                    comparisonList[0].selectedProduct.split("+")[0]
                                                    ===
                                                    client
                                                    ? 'Primary Product'
                                                    : 'Competitor Product'
                                            }}</div>
                                        </div>
                                        <div style="width: 95%;">
                                            <Treeselect v-if="allProducts.length" class="text-capitalize"
                                                v-model="comparisonList[0].selectedProduct" :options="allProducts"
                                                placeholder="Select Product" :show-count="true" :multiple="false"
                                                @input="updateComparisonData(0)" :clearable="false"
                                                :disableBranchNodes="true" :searchable="true">
                                                <span slot="noResult">Oops! No elements found. Consider changing the
                                                    search
                                                    query.</span>
                                                <label slot="option-label" slot-scope="{node, labelClassName}"
                                                    :title="node.label" :class="{
                                                        'text-truncate d-flex align-items-center text-capitalize': !node.isBranch,
                                                        'tree-leaf': node.isBranch
                                                    }">{{ node.label }}</label>
                                            </Treeselect>
                                        </div>
                                    </b-col>
                                </b-row>
                                <div class="px-2">
                                    <ReviewsAndRatings v-if="Object.keys(comparisonList[0].ratingsData).length"
                                        :ratingsData="comparisonList[0].ratingsData" />
                                </div>
                            </div>
                            <div class="compare-card my-3 px-2 py-3"
                                v-if="Object.keys(comparisonList[0].sentiments).length">
                                <Sentiments :sentimentsData="comparisonList[0].sentiments.sentiment" :navigation="true"
                                    @navigate-to-sentiment-details="navigateWordCloud('word-cloud-0')" />
                            </div>
                            <div id="word-cloud-0" class="compare-card my-3 px-2 py-3"
                                v-if="Object.keys(comparisonList[0].sentiments).length">
                                <div>
                                    <p class="heading">Positive Sentiments</p>
                                    <WordCloud v-if="comparisonList[0].sentiments.word_clowd.positive.length"
                                        :cloudData="comparisonList[0].sentiments.word_clowd.positive" color="#065559" />
                                    <div v-else style="height: 350px;">
                                        <div class="px-4 py-2" style="color: var(--red-80);">No Data</div>
                                    </div>
                                </div>
                            </div>
                            <div class="compare-card mt-3 px-2 py-3"
                                v-if="Object.keys(comparisonList[0].sentiments).length">
                                <div>
                                    <p class="heading">Negative Sentiments</p>
                                    <WordCloud v-if="comparisonList[0].sentiments.word_clowd.negative.length"
                                        :cloudData="comparisonList[0].sentiments.word_clowd.negative" color="#FD5542" />
                                    <div v-else style="height: 350px;">
                                        <div class="px-4 py-2" style="color: var(--red-80);">No Data</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-col>
                    <b-col cols="8">
                        <div class="d-flex w-100 px-1 thin-scroller" style="overflow-x: auto; min-height: 100%;">
                            <div v-for="index in 5" class="mx-1" :id="'compare-card-' + index" style="min-width: 50%;"
                                v-if="comparisonList[index]">
                                <div class="compare-card">
                                    <b-row>
                                        <b-col>
                                            <LogoContainer :imgSrc="comparisonList[index].img"
                                                :placeholder="comparisonList[index].img ? false : true"
                                                :imageHeight="170" />
                                        </b-col>
                                        <b-col class="px-2 d-flex flex-column justify-content-between position-relative"
                                            style="gap: 8px">
                                            <div class="mb-4 mt-2" style="font-size: 16px;">
                                                <span class="font-weight-bold text-capitalize"
                                                    style="color: #065559;">{{
                                                        selectedCategory.value }}:
                                                </span>
                                                <span class="text-capitalize">{{
                                                    comparisonList[index].selectedProduct &&
                                                    comparisonList[index].selectedProduct.split("+")[0]
                                                }}</span>
                                                <div class="mt-2" style="color: #5e5e5e;">{{
                                                    comparisonList[index].selectedProduct &&
                                                        comparisonList[index].selectedProduct.split("+")[0]
                                                        ===
                                                        client
                                                        ? 'Primary Product'
                                                        : 'Competitor Product'
                                                }}</div>
                                            </div>
                                            <div style="width: 95%;">
                                                <Treeselect v-if="allProducts.length" class="text-capitalize"
                                                    v-model="comparisonList[index].selectedProduct"
                                                    :options="allProducts" placeholder="Select Product"
                                                    :show-count="true" :multiple="false"
                                                    @input="updateComparisonData(index)" :clearable="false"
                                                    :disableBranchNodes="true" :searchable="true">
                                                    <span slot="noResult">Oops! No elements found. Consider changing the
                                                        search
                                                        query.</span>
                                                    <label slot="option-label" slot-scope="{node, labelClassName}"
                                                        :title="node.label" :class="{
                                                            'text-truncate d-flex align-items-center text-capitalize': !node.isBranch,
                                                            'tree-leaf': node.isBranch
                                                        }">{{ node.label }}</label>
                                                </Treeselect>
                                            </div>
                                            <div class="close-card" @click="removeCompareCard(index)">
                                                <i class="fa fa-close"></i>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <div class="px-2">
                                        <ReviewsAndRatings v-if="Object.keys(comparisonList[index].ratingsData).length"
                                            :ratingsData="comparisonList[index].ratingsData" />
                                    </div>
                                </div>
                                <div class="compare-card my-3 px-2 py-3"
                                    v-if="Object.keys(comparisonList[index].sentiments).length">
                                    <Sentiments :sentimentsData="comparisonList[index].sentiments.sentiment"
                                        :navigation="true"
                                        @navigate-to-sentiment-details="navigateWordCloud(`word-cloud-${index}`)" />
                                </div>
                                <div :id="'word-cloud-' + index" class="compare-card my-3 px-2 py-3"
                                    v-if="Object.keys(comparisonList[index].sentiments).length">
                                    <div>
                                        <p class="heading">Positive Sentiments</p>
                                        <WordCloud v-if="comparisonList[index].sentiments.word_clowd.positive.length" :cloudData="comparisonList[index].sentiments.word_clowd.positive"
                                            color="#065559" />
                                        <div v-else style="height: 350px;">
                                            <div class="px-4 py-2" style="color: var(--red-80);">No Data</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="compare-card mt-3 px-2 py-3"
                                    v-if="Object.keys(comparisonList[index].sentiments).length">
                                    <div>
                                        <p class="heading">Negative Sentiments</p>
                                        <WordCloud v-if="comparisonList[index].sentiments.word_clowd.negative.length" :cloudData="comparisonList[index].sentiments.word_clowd.negative"
                                            color="#FD5542" />
                                        <div v-else style="height: 350px;">
                                            <div class="px-4 py-2" style="color: var(--red-80);">No Data</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="comparisonList.length < 5" class="d-flex"
                                :style="comparisonList.length < 2 ? 'min-width: 90%;' : 'min-width: 45%;'">
                                <div class="add-comparison mx-1 w-100">
                                    <div class="plus-icon" @click="prepareComparisonList">
                                        +
                                    </div>
                                    <div style="font-size:16px; font-weight: 500;">
                                        Add Product
                                    </div>
                                </div>
                                <div class="add-comparison" v-if="comparisonList.length < 2"
                                    :style="comparisonList.length === 2 ? 'min-width: 50%' : 'min-width: 45%'">
                                    <div class="plus-icon" @click="prepareComparisonList">
                                        +
                                    </div>
                                    <div style="font-size:16px; font-weight: 500;">
                                        Add Product
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-col>
                </b-row>

                <div class="mx-2 card" v-if="Object.keys(reviewCountChart).length">
                    <div class="d-flex justify-content-between align-items-center card-heading">
                        <p>Number of Reviews</p>
                        <b-button-toolbar aria-label="Toolbar with buttons group">
                            <b-form-radio-group class="mr-3 radiohide" id="radiosBtn" buttons
                                button-variant="outline-secondary" v-model="reviewCountInterval"
                                @change="changeCountInterval" name="radiosBtn">
                                <b-form-radio class="mx-0" value="day">Day</b-form-radio>
                                <b-form-radio class="mx-0" value="week">Week</b-form-radio>
                                <b-form-radio class="mx-0" value="month">Month</b-form-radio>
                            </b-form-radio-group>
                        </b-button-toolbar>
                    </div>
                    <MultiLineChart :rawData="reviewCountChart" legendVerticalAlign="bottom"
                        legendHorizontalAlign="left" />
                </div>
                <div class="mx-2 card" v-if="vocData.length">
                    <div class="d-flex justify-content-between align-items-center card-heading">
                        <p>Voice of Customers</p>
                    </div>
                    <b-row>
                        <b-col cols="5" v-if="vocPieChart.length" style="border-right: 1px solid #D9D9D9;">
                            <ThinPie :rawData="vocPieChart" :noTotalText="true" innerSize="30%" :formatLegend="false"
                                :dataLabel="true" />
                        </b-col>
                        <b-col cols="7" v-if="Object.keys(vocStack).length">
                            <StackChart :rawData="vocStack" />
                        </b-col>
                    </b-row>
                </div>
            </div>
        </div>
        <b-modal size="md" class="customModal" hide-footer style="z-index: 3000 !important; text-transform: capitalize"
            v-model="showViewModal" :title="viewModalName">
            <div class="customMultiselect" v-if="viewModalName === 'Save View'">
                <multiselect v-model="selectedModalView" :options="modalViewOptions" :multiple="false"
                    :searchable="false" placeholder="Select View" label="view_name" track-by="view_id"
                    :showLabels="false" :close-on-select="true" :allow-empty="false">
                </multiselect>
            </div>
            <input required type="text" v-model="newViewName" class="text-capitalize customInput px-2"
                v-show="viewModalName === 'Edit View' || (viewModalName === 'Save View' && selectedModalView.view_id === 'add_new')" />
            <div class="d-flex justify-content-end align-items-center mt-3">
                <button class="btn navigation-btn" :disabled="spinLoader" @click="saveCompareView">
                    <b-spinner small class="mr-2" v-if="spinLoader"></b-spinner>
                    <span>Save View</span>
                </button>
            </div>
        </b-modal>
        <b-modal title="Delete View" v-model="showDeleteModal" class="container-modal-ASIN">
            <div class="modal-delete-content d-flex align-items-start mb-2">
                <div class="delete-alert text-center rounded-circle px-2 mr-3">&#9888;</div>
                <div>You're going to delete this View from the View List.<br>Are you sure ?</div>
            </div>
            <div class="d-flex justify-content-end">
                <b-button @click="showDeleteModal = false" class="btn primarycolor">No, Keep It.</b-button>
                <button @click="deleteView" :disabled="spinLoader"
                    class="btn primarycolor px-3 py-1 ml-2 d-flex align-items-center delete-viewBtn"
                    style="background-color: var(--red)">
                    <b-spinner small class="mr-2" v-if="spinLoader"></b-spinner>
                    <span>Yes, Delete!</span>
                </button>
            </div>
        </b-modal>
    </div>
</template>
<script>
import moment from 'moment';
import Multiselect from "vue-multiselect";
import LogoContainer from './Components/LogoContainer.vue';
import IconStar from '../../assets/IconStar.vue';
import ReviewsAndRatings from './Components/ReviewsAndRatings.vue';
import Sentiments from './Components/Sentiments.vue';
import WordCloud from '../commonCharts/WordCloud.vue';
import MultiLineChart from '../commonCharts/MultiLineChart.vue';
import ThinPie from '../commonCharts/ThinPie.vue';
import StackChart from '../commonCharts/StackChart.vue';
import Loader from '../Components/Loader.vue';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';


export default {
    name: "ProductReviews",
    components: {
        Treeselect,
        Loader,
        Multiselect,
        LogoContainer,
        IconStar,
        ReviewsAndRatings,
        Sentiments,
        WordCloud,
        MultiLineChart,
        ThinPie,
        StackChart
    },
    data() {
        return {
            loader: false,
            reviewLoader: false,
            countLoader: false,
            spinLoader: false,
            savedViewLoader: false,
            vocLoader: false,
            dateRange: {
                startDate: moment().startOf('year').format("YYYY-MM-DD"),
                endDate: moment().format("YYYY-MM-DD")
            },
            maxDate: new Date(),
            minDate: new Date(moment().subtract(3, 'years')),
            client: JSON.parse(localStorage.reviewUserData).data.client,
            platforms: [],
            selectedPlatform: "",
            categories: {},
            selectedCategory: {},
            tabs: ['Most Reviewed', 'Least Reviewed', 'Top Reviewed', 'Worst Reviewed'],
            selectedTab: "Most Reviewed",
            topProducts: [],
            tabKeyMapper: {
                'Most Reviewed': {
                    keyVal: 'count',
                    keyType: 'increasing'
                },
                'Least Reviewed': {
                    keyVal: 'count',
                    keyType: 'decreasing'
                },
                'Top Reviewed': {
                    keyVal: 'ratings',
                    keyType: 'increasing'
                },
                'Worst Reviewed': {
                    keyVal: 'ratings',
                    keyType: 'decreasing'
                }
            },
            maxRating: 5,
            productCompare: false,
            availableProducts: JSON.parse(localStorage.demo_voc_product_list),
            filteredProducts: [],
            comparisonList: [],
            numberOfReviews: [],
            reviewCountChart: {},
            reviewCountInterval: 'week',
            vocData: [],
            vocPieChart: [],
            vocStack: {},
            allProducts: [],
            defaultComparisonProduct: null,
            savedViews: [],
            viewOptions: [],
            selectedView: "",
            showViewModal: false,
            viewModalName: "",
            showDeleteModal: false,
            newViewName: "",
            selectedModalView: {
                view_id: 'add_new',
                view_name: 'Add New'
            },
            modalViewOptions: [],
        }
    },
    mounted() {
        this.getPlatformsAndCategories();
        this.$store.dispatch("DemoStore/setTimeStamp", ""); //using for clear the last updated time stamp
    },
    methods: {
        percentage(rating) {
            return (rating / this.maxRating) * 100;
        },
        navigateWordCloud(id) {
            document.getElementById(id).scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' })
        },
        changePlatform() {
            this.selectedCategory = this.categories[this.selectedPlatform.platform_name][0];
            this.getAllProducts();
        },
        backToTopPerformance() {
            this.productCompare = false;
            this.comparisonList = [];
            localStorage.removeItem("compareProducts");
            this.getTopProducts();
        },
        goToProductSentiments() {
            localStorage.setItem("compareProducts", true);
            if (this.selectedView) {
                localStorage.setItem('savedView', this.selectedView.view_id);
            }
            this.$nextTick(() => {
                this.$router.push("/sentiment/product");
            });
        },
        applyFilters() {
            if (!this.productCompare) {
                this.$nextTick(() => {
                    this.getTopProducts();
                })
            } else {
                for (let itemIndex in this.comparisonList) {
                    this.getProductReviews(itemIndex);
                }
                if (this.comparisonList.length > 1) {
                    this.updateVOCData();
                };
            }
        },
        setProductComparison() {
            this.comparisonList = [];
            this.getSavedViews();
            this.prepareComparisonList();
            this.productCompare = true;
        },
        updateVOCData() {
            this.getReviewCount();
            this.getVoiceOfCustomer();
        },
        updateComparisonData(index) {
            this.getProductReviews(index);
            if (this.comparisonList.length > 1) {
                this.updateVOCData();
            }
        },
        removeCompareCard(index) {
            this.comparisonList.splice(index, 1);
        },
        prepareComparisonList() {
            if (!this.comparisonList.length) {
                this.comparisonList.push({
                    selectedProduct: this.defaultComparisonProduct,
                    ratingsData: {},
                    sentiments: [],
                    currentTab: "Sentiment Overview",
                    img: "",
                })
                this.getProductReviews(0);
            } else {
                this.comparisonList.push({
                    selectedProduct: null,
                    ratingsData: {},
                    sentiments: [],
                    currentTab: "Sentiment Overview",
                    img: ""
                })
            }

            this.$nextTick(() => {
                if (this.comparisonList.length > 1 && this.comparisonList.length < 5) {
                    document.getElementById(`compare-card-${this.comparisonList.length - 1}`).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
                    const main = document.getElementsByTagName('main');
                    main.scrollTop = 0;
                    document.documentElement.scrollTop = 0;
                }
            })
        },
        getUpdatedProduct(index) {
            this.getProductReviews(index);
            if (this.comparisonList.length > 1) {
                this.updateVOCData();
            }
        },
        slideTab(id, tabName, index) {
            this.comparisonList[index].currentTab = tabName;
            document.getElementById(id).scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' })
        },
        getAllProducts() {
            this.vocData = [];
            this.vocPieChart = [];
            this.vocStack = {};
            this.reviewCountChart = {};

            const url = "/api/v2/indian_clients/product_brand";
            const payload = {
                start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                client: this.client,
                channel: this.selectedPlatform.platform_name,
                category: this.selectedCategory.key,
                label: "product"
            }

            this.loader = true;
            this.$http.post(url, payload).then(res => {
                res.body.data.map(brand => {
                    brand.children.map((product, index) => {
                        product.id = `${brand.id}+${product.id}`;
                        if (brand.id === this.client && index === 0) {
                            this.defaultComparisonProduct = product.id;
                        }
                    })
                })

                this.allProducts = res.body.data;

                if (localStorage.savedView) {
                    this.getSavedViews();
                } else {
                    this.plotProducts();
                }
                this.loader = false;
            }).catch(err => {
                this.loader = false;
                console.log("Error in getting all products", err)
            })
        },
        getPlatformsAndCategories() {
            this.platforms = [];
            this.selectedPlatform = "";
            this.categories = {};
            this.selectedCategory = [];

            const url = "/api/v2/india_clients/product_platform_details";
            const payload = {
                client: this.client,
                start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                non_sov: true
            }

            this.loader = true;

            this.$http.post(url, payload).then(res => {
                this.loader = false;
                this.platforms = res.body.data.platform;
                this.selectedPlatform = this.platforms[0];
                this.categories = res.body.data.category;
                this.selectedCategory = this.categories[this.selectedPlatform.platform_name][0]
                this.getAllProducts();

                if (localStorage.compareProducts) {
                    this.productCompare = localStorage.compareProducts;
                } else {
                    this.getTopProducts();
                }

                localStorage.removeItem('compareProducts');
            }).catch(err => {
                this.loader = false
                console.log("Error in fetching platforms and categories", err)
            })
        },
        plotProducts() {
            this.$nextTick(() => {
                if (this.productCompare) {
                    this.comparisonList = [];
                    this.prepareComparisonList();
                } else {
                    this.getTopProducts();
                }
            })
        },
        switchTab(tabName) {
            this.selectedTab = tabName;
            this.getTopProducts();
        },
        getTopProducts() {
            const url = "/api/v2/indian_clients/top_products";
            const payload = {
                start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                client: this.client,
                channel: this.selectedPlatform.platform_name,
                brand: [this.client],
                category: [this.selectedCategory.key],
                key_value: this.tabKeyMapper[this.selectedTab].keyVal,
                key_type: this.tabKeyMapper[this.selectedTab].keyType
            }

            this.reviewLoader = true;
            this.topProducts = [];

            this.$http.post(url, payload).then(res => {
                this.reviewLoader = false;
                this.topProducts = res.body.data;
            }).catch(err => {
                this.reviewLoader = false;
                console.log(`Error in getting top products`, err)
            })
        },
        getProductReviews(index = 0) {
            const productDetails = this.comparisonList[index].selectedProduct.split("+");
            const brandName = productDetails[0];
            const productName = productDetails[1];

            this.comparisonList[index].ratingsData = {};
            this.comparisonList[index].sentiments = [];

            const url = "/api/v2/indian_clients/compare_data";
            const payload = {
                start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                client: this.client,
                channel: this.selectedPlatform.platform_name,
                compare: [{
                    brand_name: brandName,
                    category_name: this.selectedCategory.key,
                    product_name: productName
                }],
                compare_type: "product"
            }

            this.reviewLoader = true;

            this.$http.post(url, payload).then(res => {
                this.reviewLoader = false;
                this.comparisonList[index].ratingsData = res.body.data[productName].reviews.ratings;
                this.comparisonList[index].sentiments = res.body.data[productName].sentiment;
                this.comparisonList[index].img = res.body.data[productName].product_image;
            }).catch(err => {
                this.reviewLoader = false;
                console.log(`Error in getting product review`, err);
            })
        },
        getVoiceOfCustomer() {
            let products = this.comparisonList.map(product => product.selectedProduct.split("+")[1]);
            this.numberOfReviews = [];
            this.reviewCountChart = {};
            this.vocData = [];
            this.vocPieChart = [];
            this.vocStack = {}

            const url = `/api/v2/reviews/bulk?`;

            const payload = {
                channel: this.selectedPlatform.platform_name,
                start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                interval: "month",
                products: products
            }
            this.vocLoader = true;

            this.$http.post(url, payload).then(res => {
                this.vocLoader = false;
                this.vocData = res.body.data;
                this.$nextTick(() => {
                    this.plotVOCCharts();
                })
            }).catch(err => {
                this.vocLoader = false;
                console.log(`Error in getting voice of customers`, err)
            })
        },
        plotVOCCharts() {
            const pieColors = ["#FCB117", "#46A493", "#899EFC"];

            let stackCategories = [];
            let positiveData = [];
            let negativeData = [];
            let neutralData = [];

            let pieChartData = [{
                name: 'Voice of Customers',
                colorByPoint: true,
                data: []
            }];

            this.vocData.map((series, index) => {
                stackCategories.push(series.product_name);

                positiveData.push(series.rating_sentiment.positive.count);
                negativeData.push(series.rating_sentiment.negative.count);
                neutralData.push(series.rating_sentiment.neutral.count);

                pieChartData[0].data.push({
                    name: series.product_name,
                    y: series.count,
                    color: pieColors[index]
                });
            });

            this.vocStack = {
                categories: stackCategories,
                seriesData: [
                    {
                        name: "Positive",
                        data: positiveData,
                        color: "#46a493",
                        borderRadius: "15px"
                    },
                    {
                        name: "Neutral",
                        data: neutralData,
                        color: "#dcdcdc",
                        borderRadius: 0
                    },
                    {
                        name: "Negative",
                        data: negativeData,
                        color: "#fc8484",
                        borderRadius: 0
                    }
                ]
            }

            this.vocPieChart = pieChartData;
        },
        changeCountInterval() {
            this.$nextTick(() => {
                this.getReviewCount();
            })
        },
        getReviewCount() {
            let products = this.comparisonList.map(product => product.selectedProduct.split("+")[1]);
            this.numberOfReviews = [];
            this.reviewCountChart = {};

            let startDate = moment(this.dateRange.startDate).format("YYYY-MM-DD");
            if (this.reviewCountInterval === 'week' || this.reviewCountInterval === 'day') {
                startDate = moment(this.dateRange.endDate).subtract(1, 'month').format("YYYY-MM-DD");
            }

            const url = `/api/v2/reviews/histogram`;

            const payload = {
                channel: this.selectedPlatform.platform_name,
                start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                interval: this.reviewCountInterval,
                products: products
            }

            this.countLoader = true;

            this.$http.post(url, payload).then(res => {
                this.countLoader = false;
                this.numberOfReviews = res.body.data;
                this.prepareReviewCountChartData();
            }).catch(err => {
                this.countLoader = false;
                console.log(`Error in getting review count timeline data`, err)
            })
        },
        prepareReviewCountChartData() {
            let colors = ["#FCB117", "#46A493", "#899EFC"]
            let xAxisData = [];
            let yAxisData = [];

            this.numberOfReviews.forEach((reviewSeries, index) => {
                yAxisData.push({
                    name: reviewSeries.product_name,
                    data: [],
                    color: colors[index]
                })

                reviewSeries.timeline.forEach(seriesData => {
                    if (index === 0) {
                        xAxisData.push(moment(seriesData.date).format("DD MMM"))
                    }
                    yAxisData[index].data.push(seriesData.review_count)
                })
            })

            this.reviewCountChart = {
                categories: xAxisData,
                seriesData: yAxisData
            }
        },
        getSelectedSavedView() {
            this.savedViewLoader = true;
            this.comparisonList = [];

            const targetView = this.savedViews.find(view => view.view_id === this.selectedView.view_id);

            this.dateRange = targetView.page_filter.dateRange;
            this.selectedPlatform = targetView.page_filter.selectedPlatform;
            this.selectedCategory = targetView.page_filter.selectedCategory;

            const compareBrandPayload = [];

            targetView.product_filter.map((brand, index) => {
                this.comparisonList.push({
                    selectedProduct: `${brand.selectedBrand}+${brand.selectedProduct}`,
                    ratingsData: {},
                    sentiments: [],
                    currentTab: "Sentiment Overview",
                    img: "",
                })

                compareBrandPayload.push({
                    brand_name: brand.selectedBrand,
                    category_name: this.selectedCategory.key,
                    product_name: brand.selectedProduct
                })

            })

            this.$nextTick(() => {
                const url = "/api/v2/indian_clients/compare_data";
                const payload = {
                    start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                    end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                    client: this.client,
                    channel: this.selectedPlatform.platform_name,
                    compare: compareBrandPayload,
                    compare_type: "product"
                };

                this.reviewLoader = true;

                this.$http.post(url, payload).then(res => {
                    this.reviewLoader = false;
                    this.comparisonList.forEach((brand, index) => {

                        const productName = brand.selectedProduct.split("+")[1];

                        this.comparisonList[index].ratingsData = res.body.data[productName].reviews.ratings;
                        this.comparisonList[index].sentiments = res.body.data[productName].sentiment;
                        this.comparisonList[index].img = res.body.data[productName].product_image;
                    })

                    this.$nextTick(() => {
                        this.getVoiceOfCustomer();
                        this.getReviewCount();
                    })
                }).catch(err => {
                    this.reviewLoader = false;
                    console.log("Error in getting compare brand data", err)
                })
                this.savedViewLoader = false;
            });
        },
        resetViewModal() {
            this.viewModalName = "";
            this.newViewName = "";
            this.modalViewOptions = [];
            this.showViewModal = false;
        },
        openViewModal(viewType) {
            this.modalViewOptions = [
                ...this.viewOptions,
                {
                    view_id: 'add_new',
                    view_name: 'Add New'
                },
            ];

            if (viewType === 'Edit View') {
                this.newViewName = this.selectedView.view_name;
            } else if (viewType === 'Save View') {
                this.selectedModalView = {
                    view_id: 'add_new',
                    view_name: 'Add New'
                };

                this.newViewName = "";
            }

            this.$nextTick(() => {
                this.viewModalName = viewType;
                this.showViewModal = true;
            })
        },
        getSavedViews() {
            this.savedViews = [];
            this.viewOptions = [];
            const url = "/api/v2/reviews/comparison_view?view_for=product_reviews_compare";

            this.$http.get(url).then(res => {
                this.savedViews = res.data.data;
                if (this.savedViews.length) {
                    this.savedViews.map(view => {
                        this.viewOptions.push({
                            view_id: view.view_id,
                            view_name: view.view_name
                        })
                    })
                }

                if (localStorage.savedView) {
                    this.selectedView = this.viewOptions.find(view => view.view_id === localStorage.savedView);
                    localStorage.removeItem("savedView");
                    this.$nextTick(() => {
                        this.getSelectedSavedView();
                    });
                }

                if (
                    this.viewModalName === 'Edit View' ||
                    (
                        this.viewModalName === 'Save View' &&
                        this.selectedModalView.view_id === 'add_new'
                    )
                ) {
                    this.selectedView = this.viewOptions.find(view => view.view_name === this.newViewName);
                    this.resetViewModal();
                } else this.resetViewModal();
            }).catch(err => {
                console.log(`Error getting saved views:: ${err}`);
            })
        },
        saveCompareView() {
            if (this.viewModalName === "Edit View" && !this.newViewName) {
                this.$bvToast.toast('Please provide a name to edit this view', {
                    title: 'Edit View',
                    variant: 'danger',
                    solid: true,
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 2000,
                    appendToast: true,
                });
                return;
            } else if (this.selectedModalView.view_id === "add_new" && !this.newViewName) {
                this.$bvToast.toast('Please provide a name to save new view', {
                    title: 'Save View',
                    variant: 'danger',
                    solid: true,
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 2000,
                    appendToast: true,
                });
                return;
            }

            this.spinLoader = true;

            if (this.newViewName) {
                let capitalizedText;
                capitalizedText = this.newViewName.split(' ').map(word =>
                    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                ).join(' ');

                this.newViewName = capitalizedText;
            }

            const url = "/api/v2/reviews/comparison_view";
            let payload = {
                view_for: "product_reviews_compare",
                view_data: {
                    page_filter: {
                        dateRange: {
                            startDate: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                            endDate: moment(this.dateRange.endDate).format("YYYY-MM-DD")
                        },
                        selectedPlatform: this.selectedPlatform,
                        selectedCategory: this.selectedCategory
                    },
                    product_filter: this.comparisonList.map(compareProduct => {
                        return {
                            selectedBrand: compareProduct.selectedProduct.split("+")[0],
                            selectedProduct: compareProduct.selectedProduct.split("+")[1]
                        }
                    }),
                    view_name: this.newViewName
                },
            };

            if (this.viewModalName === 'Edit View') {
                payload = {
                    ...payload,
                    view_id: this.selectedView.view_id
                }
            }

            if (this.viewModalName === 'Save View' && this.selectedModalView.view_id !== 'add_new') {
                payload.view_data.view_name = this.selectedModalView.view_name,
                    payload = {
                        ...payload,
                        view_id: this.selectedModalView.view_id
                    }
            }

            this.$http.post(url, payload).then(res => {
                this.getSavedViews();
                this.spinLoader = false;
            }).catch(err => {
                console.log(`Error in saving view::${err}`);
                this.spinLoader = false;
            });
        },
        resetComparisonList() {
            if (this.productCompare) {
                this.comparisonList = [];
                this.$nextTick(() => {
                    this.prepareComparisonList();
                })
            }
        },
        resetSavedView() {
            this.selectedView = "";
            this.resetComparisonList();
        },
        deleteView() {
            const url = "/api/v2/reviews/comparison_view";
            let payload = {
                view_id: [this.selectedView.view_id],
                view_for: "product_reviews_compare"
            }

            this.spinLoader = true;
            this.$http.delete(url, { body: payload }).then((res) => {

                this.getSavedViews();
                this.resetSavedView();

                this.$bvToast.toast('View deleted successfully', {
                    title: 'Delete View',
                    variant: 'success',
                    solid: true,
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 2000,
                    appendToast: true,
                });

                this.spinLoader = false;

            }).catch((err) => {
                console.log(err);
                this.$bvToast.toast('Error in deleting this view', {
                    title: 'Delete View',
                    variant: 'danger',
                    solid: true,
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 2000,
                    appendToast: true,
                });
                this.spinLoader = false;
            })

            this.showDeleteModal = false;
        },
        downloadReviews() {
            this.reviewLoader = true;
            const url = "/api/v2/reviews/brand";
            const payload = {
                start_date: moment(this.dateRange.startDate).format("YYYY-MM-DD"),
                end_date: moment(this.dateRange.endDate).format("YYYY-MM-DD"),
                client: this.client,
                channel: this.selectedPlatform.platform_name,
                category: this.selectedCategory.value
            }

            this.$http.post(url, payload).then(res => {
                this.reviewLoader = false;
                window.location = res.body.data.file_url;
            }).catch(err => {
                this.$bvToast.toast('Error in downloading reviews', {
                    title: 'Download Reviews',
                    variant: 'danger',
                    solid: true,
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 2000,
                    appendToast: true,
                });
                console.log("Error in downloading report", err)
            })
        }
    }
}
</script>
<style scoped>
.customInput {
    border-radius: 5px !important;
    height: 35px !important;
    border: 1px solid #e4e7ea;
    width: 220px;
    outline: none;
    font-family: 'poppins';
    width: 100%
}

.customInput:focus {
    border: 1px solid var(--primary_brand) !important;
    box-shadow: none !important;
}

.delete-viewBtn:hover {
    background-color: #f58181 !important;
}

.delete-alert {
    background-color: #ffecec !important;
    color: var(--red);
    font-size: 30px;
    width: 45px;
    height: 45px;
}

.graphHeading {
    font-weight: 600 !important;
    font-size: 16px !important;
    color: var(--primary_brand) !important;
    letter-spacing: 0.6px !important;
    font-family: "poppins";
    text-transform: capitalize;
}

.newComparisonIcon svg {
    height: 17px;
    transform: rotate(45deg);
    color: white;
    fill: #fff;
    margin-right: 5px;
}

.close-card {
    position: absolute;
    right: 20px;
    top: 5px;
    background-color: #dedede;
    padding: 6px 10px;
    border-radius: 50%;
    cursor: pointer;
}

.close-card:hover {
    background-color: #f0f0f0;
}

.card-heading {
    padding-bottom: 10px;
    border-bottom: 1px solid #D4D4D4;

    &>p {
        font-size: 16px;
        font-weight: 600;
        line-height: 21.76px;
        color: #065559;
    }
}

.add-comparison {
    border: 1px solid #d9d9d9;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    height: 200px;
    border-radius: 10px;
    color: #5E5E5E;
}

.plus-icon {
    font-size: 30px;
    color: #5E5E5E;
    border: 2px dashed #5E5E5E;
    border-radius: 50%;
    padding-inline: 12px;
    cursor: pointer;
}

.customselect {
    height: 37px !important;
    border-radius: 5px !important;
    background: white;
    border: 1px solid #B7B7B7 !important;
    padding-left: 11px;
    padding-right: 11px;
    margin-right: 5px;
    color: var(--primary_brand);
    width: 90%;
    text-overflow: ellipsis;
}

.customselect:focus {
    outline: none !important;
    border: 1px solid var(--primary_brand) !important;
}

.compare-card {
    background-color: white;
    border-radius: 10px;
    border: 1px solid #D9D9D9;
}

.multiline-ellipsis {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 4;
    overflow: hidden;
    text-overflow: ellipsis;
}

.container {
    display: grid;
    align-items: center;
    justify-content: start;
    margin: 0;
    padding: 0;

    &>* {
        grid-column: 1;
        grid-row: 1;
    }
}

.star {
    display: flex;
    width: 16px;
    margin-right: 0px;
    color: #FCB117;
    fill: #FCB117;
}

.overlay {
    justify-self: end;
    background-color: white;
    height: 16px;
}

ul.tabs {
    display: flex;
    justify-content: flex-start;
    gap: 8px;
    margin: 0;
    padding: 0;
    border-bottom: 1px solid#D5D5D5;

    &>li {
        list-style: none;
        padding-inline: 8px;
        padding-bottom: 14px;
        cursor: pointer;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
    }

    &>li.active {
        color: #065559;
        border-bottom: 1px solid var(--primary_brand);
    }
}

.slide {
    display: flex;
    max-width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none;
    -ms-overflow-style: none;

    &>* {
        min-width: 100%;
    }
}

.slide::-webkit-scrollbar {
    display: none;
}

.tab {
    width: 30px;
    height: 7px;
    border-radius: 10px;
    background-color: #0655594D;
    cursor: pointer;
}

.active-tab {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: #00555A;
    cursor: pointer;
}

.slider-tab {
    width: 30px;
    height: 7px;
    border-radius: 10px;
    background-color: #0655594D;
    cursor: pointer;
}

.slider-active {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background-color: #00555A;
    cursor: pointer;
}

.card {
    border-radius: 0.7rem !important;
    border: none !important;
    margin-bottom: 1rem;
}

button.primarycolor {
    background: var(--primary_brand);
    font-family: "Poppins", sans-serif;
    color: white;
    padding: 7px 25px;
    border-radius: 6px;
    letter-spacing: 0.2px;
    font-weight: bold;
    font-size: 14px;
}

button.navigation-btn {
    background: var(--accent_color);
    font-family: "Poppins", sans-serif;
    color: white;
    padding: 7px 25px;
    border-radius: 6px;
    letter-spacing: 0.2px;
    font-weight: bold;
    font-size: 14px;
}

button.primarycolor:hover {
    color: white;
    background: var(--primary_brand-80);
    /* border: 1.6px solid var(--base_color); */
}

button.navigation-btn:hover {
    background: var(--accent_color-80);
}

.label {
    font-size: 14px;
    font-weight: 500;
    color: #1E1E1E
}

.gap {
    gap: 14px !important;
}

.customSelect :focus {
    background: var(--base_color-5) !important;
    color: var(--primary_brand-60) !important;
    border: 1px solid var(--primary_brand-60) !important;
    outline: none !important;
    box-shadow: none !important;
    font-weight: 600;
}

.form-control {
    border-radius: 5px !important;
    padding: 6px !important;
    font-size: 11px !important;
    height: 35px !important;
    border: 1px solid var(--base_color-40) !important;
}

.section-button {
    padding: 8px 16px;
    border-radius: 8px;
    border: 1px solid #065559;
    background-color: transparent;
    font-size: 14px;
    font-weight: 400;
    line-height: 19.04px;
    color: #00555A;
}

.active-button {
    background-color: #065559;
    color: white;
}

.product-section-card {
    border-radius: 10px;
    border: 1px solid #D9D9D9;
    background-color: transparent;
    height: 100%;
}

.logo-container {
    border-radius: 10px;
    border: 0px solid #D9D9D9;
    background: linear-gradient(360deg, rgba(0, 0, 0, 0.05) 0%, rgba(255, 255, 255, 0) 100%);
    box-shadow: 0px 1px 6px 0px #0000002E;
    max-height: 220px;
    max-width: 100%;
}

a {
    color: #0463BA;
    font-family: Poppins;
    font-size: 14px;
    font-weight: 500;
    line-height: 25px;
    text-transform: capitalize;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.tree-leaf {
    height: 25px;
    margin: auto;
    line-height: 25px;
    cursor: pointer;
}

.customMultiselect .multiselect__placeholder {
    margin-bottom: 6px !important;
    padding: 0px !important;
    color: var(--primary_brand-40) !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__tags {
    border: 1px solid var(--base_color-40) !important;
    padding-top: 6px !important;
    min-height: 35px !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__select {
    min-height: 35px !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__select::before {
    top: 56% !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__tag {
    background: var(--primary_brand-80) !important;
    margin-bottom: 0px !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__tag-icon:after {
    color: #fff !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__content-wrapper {
    border: 1px solid var(--base_color-40) !important;
    border-top: none !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__option--selected.multiselect__option--highlight {
    background: var(--red) !important;
    color: var(--white) !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__option--highlight {
    background: var(--base_color-20) !important;
    color: var(--primary_brand-80) !important;
    font-family: "poppins";
}

.customMultiselect .multiselect__element {
    color: var(--primary_brand-80) !important;
    border-bottom: 1px solid var(--base_color-20);
    font-family: "poppins";
}

/* width */
.customMultiselect ::-webkit-scrollbar {
    width: 10px;
    border-radius: 10px;
}

/* Track */
.customMultiselect ::-webkit-scrollbar-track {
    background: var(--base_color-20);
    border-radius: 10px;
}

/* Handle */
.customMultiselect ::-webkit-scrollbar-thumb {
    background: var(--base_color-80);
    border-radius: 10px;
}

/* Handle on hover */
.customMultiselect ::-webkit-scrollbar-thumb:hover {
    background: var(--base_color);
}
</style>